import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';

export default function Eliminator535Page() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <div className="bg-[#f5f5f5] py-4">
        <div className="container mx-auto px-4">
          <h5 className="text-sm text-[#333333]">
            <Link to="/" className="hover:underline">Home</Link> / 535 ELIMINATOR
          </h5>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Images */}
          <div>
            <div className="mb-4">
              <img 
                              src="/images/535_0319-scaled.jpg" 
                alt="535 Eliminator" 
                className="w-full rounded-lg"
              />
            </div>
          </div>

          {/* Right Column - Product Info */}
          <div>
            
            
            <h1 className="text-4xl font-bold text-[#333333] mb-4">535 ELIMINATOR</h1>
            <h4 className="text-xl text-[#666666] mb-2">Model: 535000</h4>
            <h4 className="text-xl text-[#666666] mb-6">Weight: 808 lbs</h4>

            <div className="prose max-w-none mb-8">
              <h2 className="text-2xl font-bold text-[#333333] mb-4">Advanced Tree Removal Skid Steer Attachment</h2>
              <p className="text-[#666666] mb-4">
                The 535 ELIMINATOR is a next-generation tree removal skid steer attachment built for serious clearing power and added versatility. Engineered to uproot trees completely—roots and all—this heavy-duty tool features enhanced digging and cutting performance to tackle even the most stubborn growth.
              </p>
              <p className="text-[#666666] mb-4">
                Ideal as both a small tree puller and a solution for larger-diameter trees, the 535 ELIMINATOR combines powerful gripping jaws with extended blades and an oversized root ripper. It's perfect for landowners and professionals who need to remove trees, posts, stakes, or even large rocks and debris.
              </p>
              <p className="text-[#666666] mb-4">
                The standout feature? A built-in saw that lets you handle trees up to 12 inches in diameter—making it more than just a small tree puller, but a complete land-clearing solution.
              </p>
              <p className="text-[#666666]">
                Whether you're clearing small growth or tackling mature trees, the 535 ELIMINATOR delivers the strength, precision, and versatility you need from a top-tier tree removal skid steer attachment.
              </p>
            </div>

            <hr className="my-8 border-[#e5e5e5]" />

            {/* Features Accordion */}
            <div className="mb-8">
              <details className="group" open>
                <summary className="flex justify-between items-center cursor-pointer list-none py-4 border-b border-[#e5e5e5]">
                  <span className="text-lg font-bold text-[#333333]">FEATURES</span>
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="py-4">
                  <ul className="list-disc pl-6 space-y-2 text-[#666666]">
                    <li>Extended blade length by 6" for deeper digging power</li>
                    <li>Double-sized root ripper for enhanced root cutting</li>
                    <li>8" wide reversed spade points for improved soil penetration</li>
                    <li>Open blade spacing for dirt and debris to flow through easily</li>
                    <li>Hydraulic hose holder (TAMEit) for organized hose management</li>
                    <li>Open tips reduce damage when pulling "T" posts and stakes</li>
                    <li>Extra-long 90° blade teeth for maximum grip</li>
                    <li>Built-in saw feature cuts trees up to 12" in diameter from one side</li>
                  </ul>
                  <h4 className="font-bold text-[#333333] mt-4 mb-2">Added Features With The "Eliminator":</h4>
                  <ul className="list-disc pl-6 space-y-2 text-[#666666]">
                    <li>The new SAW feature allows you to saw a tree that may be too large to pull. The maximum saw diameter is 12" from one side</li>
                  </ul>
                </div>
              </details>
            </div>

            {/* CTA Buttons */}
            <div className="space-y-4">
              <a 
                href="/contact" 
                className="block w-full bg-[#d4af37] text-white text-center py-3 px-6 font-bold hover:bg-[#c19b2a] transition-colors"
              >
                Call Us Now
              </a>
              <div className="grid grid-cols-2 gap-4">
                
               
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-16 bg-[#f5f5f5] p-8 rounded-lg">
          <h3 className="text-2xl font-bold text-[#333333] mb-6">Frequently Asked Questions</h3>
          <div className="space-y-4">
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: What sets the 535 ELIMINATOR apart from other tree removal skid steer attachments?</p>
              <p className="text-[#666666]">A: The 535 ELIMINATOR includes a built-in saw feature that allows you to cut trees up to 12 inches in diameter—something most tree removal skid steer attachments don't offer. It also features extended blades, a double-sized root ripper, and enhanced digging capabilities for full root removal.</p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: Can the 535 ELIMINATOR be used as a small tree puller?</p>
              <p className="text-[#666666]">A: Absolutely. While it's equipped for tougher jobs, the 535 functions exceptionally well as a small tree puller, gripping and removing saplings, brush, and smaller trees with ease. Its precision and strength make it versatile enough for both light and heavy-duty clearing tasks.</p>
            </div>
            <div>
              <p className="font-bold text-[#333333] mb-2">Q: Is the 535 ELIMINATOR compatible with standard skid steers?</p>
              <p className="text-[#666666]">A: Yes, the 535 is designed to work with most skid steers using a universal quick attach system. It's a powerful, easy-to-use tree removal skid steer attachment that integrates smoothly into your equipment fleet for maximum land-clearing efficiency.</p>
            </div>
          </div>
        </div>

        
         

        {/* Disclaimer */}
        <div className="mt-12 bg-[#f5f5f5] p-8 rounded-lg text-center">
          <h3 className="text-xl font-bold text-[#333333] mb-4">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h3>
          <p className="text-[#666666]">
            All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
          </p>
        </div>
      </div>

      
    </div>
  );
}
